const mediaItems = [
  {
    title: '热血日漫全集推荐',
    desc: '从经典到新番，热血战斗漫画全集一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20Japanese%20manga%20action%20scene%20with%20dynamic%20battle%20poses%2C%20warm%20orange%20and%20red%20energy%20effects%2C%20epic%20composition%2C%20illustration%20style%20on%20clean%20cream%20background%2C%20artistic%20quality&width=800&height=500&seq=media-card-01&orientation=landscape',
    tag: '日漫',
  },
  {
    title: '韩漫完结作品速览',
    desc: '高人气韩漫全集，下拉式流畅阅读体验',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20scene%20with%20soft%20warm%20lighting%2C%20elegant%20character%20illustrations%20on%20digital%20screen%2C%20clean%20modern%20aesthetic%2C%20cream%20background%20with%20subtle%20texture&width=800&height=500&seq=media-card-02&orientation=landscape',
    tag: '韩漫',
  },
  {
    title: '下拉式全集阅读指南',
    desc: '全新阅读模式，一次性看完整部完结漫画',
    img: 'https://readdy.ai/api/search-image?query=Modern%20tablet%20device%20showing%20continuous%20scroll%20manga%20reading%20interface%20with%20colorful%20panels%2C%20cozy%20reading%20nook%20atmosphere%2C%20warm%20ambient%20light%2C%20clean%20minimal%20composition&width=800&height=500&seq=media-card-03&orientation=landscape',
    tag: '功能',
  },
  {
    title: '完结漫画大全盘点',
    desc: '5000+完结作品库，总有你喜欢的漫画全集',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20manga%20book%20collection%20displayed%20on%20wooden%20shelves%20with%20warm%20lighting%2C%20organized%20library%20aesthetic%2C%20rich%20colors%2C%20inviting%20atmosphere%2C%20clean%20cream%20background&width=800&height=500&seq=media-card-04&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '免费全集下载教程',
    desc: '如何下载喜欢的漫画全集，随时离线阅读',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20manga%20download%20interface%20with%20progress%20bar%2C%20warm%20modern%20setting%2C%20digital%20reading%20concept%2C%20clean%20illustration%20style%20on%20light%20background&width=800&height=500&seq=media-card-05&orientation=landscape',
    tag: '教程',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          视频专区
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          精选漫画推荐与阅读指南，帮你快速发现好看的完结漫画全集
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item, i) => (
            <a key={i} href="#cards" className="group block bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-600">
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaItems.slice(3).map((item, i) => (
            <a key={i + 3} href="#cards" className="group flex bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative w-48 flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-background-50/90 text-xs font-medium text-primary-600">
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}